<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet">
        <div class="m-portlet__body">
          <div class="m-quick-sidebar__content">
            <ul
              id="m_quick_sidebar_tabs"
              class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
              role="tablist"
            >
              <li class="nav-item m-tabs__item">
                <a
                  class="nav-link m-tabs__link active"
                  data-toggle="tab"
                  href="#save_contract"
                  role="tab"
                >
                  <h5><span class="fas fa-users-medical"></span> Perfil</h5>
                </a>
              </li>
            </ul>
          </div>
          <div class="container">
            <div class="view-account">
              <div class="side-bar">
                <div class="user-info">
                  <img
                    class="img-profile img-circle img-responsive center-block"
                    src="https://bootdey.com/img/Content/avatar/avatar1.png"
                    alt=""
                  />
                  <ul class="meta list list-unstyled margin-perfil">
                    <li class="perfil-name">{{ data.name }}</li>
                    <label class="perfil-status d-none">Development</label>
                    <li class="email">
                      <a>{{ data.email }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="content-panel">
                <div
                  id="alert"
                  class="alert alert-dismissible fade show  m-alert m-alert--outline mb-4 mt-4"
                  :class="alert.color"
                  role="alert"
                  v-if="alert.message"
                >
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="alert.message = ''"
                  ></button>
                  <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                  ><br />
                  {{ alert.reason }}
                </div>
                <form class="form-horizontal">
                  <fieldset class="fieldset">
                    <h3 class="fieldset-title d-none">Admin</h3>
                    <div class="form-group">
                      <label class="col-md-2 col-sm-3 col-xs-12 control-label">Nome</label>
                      <div class="col-md-10 col-sm-9 col-xs-12">
                        <input type="text" class="form-control" v-model="data.name" />
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="fieldset">
                    <div class="form-group">
                      <label class="col-md-2  col-sm-3 col-xs-12 control-label">Senha</label>
                      <div class="col-md-10 col-sm-9 col-xs-12">
                        <input
                          type="password"
                          class="form-control"
                          placeholder=""
                          ref="password"
                          v-model="data.password"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3  col-sm-3 col-xs-12 control-label"
                        >Confirmar Senha</label
                      >
                      <div class="col-md-10 col-sm-9 col-xs-12">
                        <input
                          type="password"
                          class="form-control"
                          placeholder=""
                          ref="c_password"
                          v-model="data.c_password"
                        />
                        <span v-if="data.password != data.c_password" class="password-error">
                          Campo Senha devem ser iguais
                        </span>
                      </div>
                    </div>
                  </fieldset>
                  <div class="form-group">
                    <div
                      class="col-md-10 col-sm-9 col-xs-12 col-md-push-2 col-sm-push-3 col-xs-push-0"
                    >
                      <button
                        @click.prevent="saveForm()"
                        class="btn"
                        :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
                        :disabled="!formIsValid"
                      >
                        <i class="fas fa-save" v-if="formIsValid"></i>
                        <i class="fas fa-exclamation-triangle" v-else></i>
                        Salvar
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';

export default {
  mixins: [returnMessageFormMixin],
  name: 'Profile',
  components: {},
  data() {
    return {
      data: {},
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    saveForm() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Aguarde, salvando os dados!',
        reason: '',
      };

      const { data } = this;

      const url = `${baseApiUrl}/v1/user/edit-user`;
      axios
        .post(url, data)
        .then((res) => {
          this.alert = {
            color: 'alert-success',
            icon: 'fas fa-check fa-lg',
            message: res.data.message,
            reason: '',
          };
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    getData() {
      const url = `${baseApiUrl}/v1/user/details`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data.data;
        })
        .catch(() => {
          this.alert = {
            color: 'alert-danger',
            icon: 'fas fa-times-hexagon',
            message: 'Problemas ao buscar informaçõesdo usuário',
            reason: '',
          };
        });
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    formIsValid() {
      if (
        this.data.name &&
        (!this.data.password || (this.data.password && this.data.password === this.data.c_password))
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.user-info {
  text-align: center;
}
.img-circle {
  border-radius: 50%;
}
.fieldset-title {
  margin-left: 10px;
}
.margin-perfil {
  margin-top: 20px;
}
.perfil-name {
  font-weight: 500;
  font-size: 16px;
}
.perfil-status {
  margin-top: 2px;
  font-size: 12px;
}
.password-error {
  color: red;
}
.view-account .content-panel {
  min-height: 450px;
  border-left: 1px solid #f3f3f7;
  margin-left: 200px;
}
.view-account .mail-subject .subject {
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-account .side-bar {
  position: absolute;
  width: 200px;
  min-height: 600px;
}
.view-account .side-bar .user-info {
  margin-bottom: 0;
  border-bottom: none;
  padding: 30px;
}
.view-account .side-bar .user-info .img-profile {
  width: 120px;
  height: 120px;
}
.view-account .side-bar .side-menu {
  text-align: left;
}
.view-account .side-bar .side-menu .nav {
  display: block;
}
.view-account .side-bar .side-menu .nav > li {
  display: block;
  float: none;
  font-size: 14px;
  border-bottom: 1px solid #f3f3f7;
  margin-right: 0;
  margin-bottom: 0;
}
.view-account .side-bar .side-menu .nav > li > a {
  display: block;
  color: #9499a3;
  padding: 10px 15px;
  padding-left: 30px;
}
.view-account .side-bar .side-menu .nav > li > a:hover {
  background: #f9f9fb;
}
.view-account .side-bar .side-menu .nav > li.active a {
  background: #f9f9fb;
  border-right: 4px solid #40babd;
  border-bottom: none;
}
.theme-2 .view-account .side-bar .side-menu .nav > li.active a {
  border-right-color: #6dbd63;
}
.theme-3 .view-account .side-bar .side-menu .nav > li.active a {
  border-right-color: #497cb1;
}
.theme-4 .view-account .side-bar .side-menu .nav > li.active a {
  border-right-color: #ec6952;
}
.view-account .side-bar .side-menu .nav > li .icon {
  font-size: 24px;
  vertical-align: middle;
  text-align: center;
  width: 40px;
  display: inline-block;
}
</style>
